"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const platform_1 = require("./platform");
const utils_1 = require("./utils");
class AppInfo {
    constructor(params) {
        this.idGenerator = params.idGenerator || utils_1.Utils.getGuid;
        this.fixedHeaders = this.createHeaders(params);
    }
    getAppHeaders(_params = {}) {
        const headers = _.clone(this.fixedHeaders);
        headers[AppInfo.correlationIdHeader] += this.idGenerator();
        return headers;
    }
    createHeaders(params) {
        const fixedHeaders = {
            [AppInfo.correlationIdHeader]: (!params.correlationIdPrefix ? '' :
                `${params.correlationIdPrefix}-`).toLowerCase(),
        };
        if (params.enableAppHeader) {
            this.appendToAppHeader(fixedHeaders, this.createVersionedCategory({
                category: 'app',
                namedVersion: params.app,
            }));
            this.appendToAppHeader(fixedHeaders, this.createVersionedCategory({
                category: 'platform',
                namedVersion: params.platform || platform_1.Platform.detectPlatform(),
            }));
            this.appendToAppHeader(fixedHeaders, `session=${this.idGenerator()}`);
        }
        return fixedHeaders;
    }
    appendToAppHeader(headers, value) {
        if (value) {
            headers[AppInfo.appHeader] = `${(headers[AppInfo.appHeader] || '')}${value.toLowerCase()};`;
        }
    }
    createVersionedCategory(params) {
        return !params.namedVersion ? undefined :
            `${params.category}=${params.namedVersion.name}${!params.namedVersion.version ? '' : '/' + params.namedVersion.version}`;
    }
}
exports.AppInfo = AppInfo;
AppInfo.correlationIdHeader = 'x-mitel-correlation-id';
AppInfo.appHeader = 'x-mitel-app';
//# sourceMappingURL=app-info.js.map